  	// Ajax Pagination on collection page
      document.addEventListener("DOMContentLoaded", function() {
        var endlessScroll = new Ajaxinate({
          container: '#AjaxinateContainer',
          pagination: '#AjaxinatePagination',
          loadingText: 'Loading More...',
//           method:'click',
          callback: nextPage,
          beforeSend:()=>{
        	$('.load-more-spinner').show();
      		$('#load-more-products').hide();
           },
          complete:()=>{
        		$('.load-more-spinner').show();
      			$('#load-more-products').hide();
        } 
      });
        function nextPage(){
          $("#AjaxinateContainer .product-area .product-item").addClass('loadmoreProductsVisible');
        }
      });